import { axios } from 'lib/axios';

export const allow2FA = (data) => {
  return axios.patch('/user/allow2FA', data);
};
